export default __webpack_public_path__ + "static/media/overcharge.85af2836.png";